export default theme => ({
	custom: {
		padding: theme.spacing(1, 0, 0, 0),
		'&:hover': {
			background: 'none'
		}
	}
});
